import React, { useState } from "react";
import {
  Box,
  TextField,
  Paper,
  Typography,
  FormControlLabel,
  Checkbox,
  Button,
  Snackbar,
  Alert,
  CircularProgress,
  Grid,
  FormGroup,
} from "@mui/material";
import axios from "axios";

const AtamaIslemleri = () => {
  const [ad, setAd] = useState("");
  const [soyad, setSoyad] = useState("");
  const [kullanici_kod, setKullaniciKod] = useState("");
  const [pass, setPass] = useState("");
  const [atananTestKodlari, setAtananTestKodlari] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(true);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const testCodeMapping = {
    "Jo-Harry Penceresi": 1,
    "Thmos-Kilmann Uyuşmazlık Envanteri": 2,
    "İletişim Tipi Envanteri": 3,
    "İletişim Tipi Envanteri 2": 4,
    "Satış Becerileri Envanteri": 5,
    "Satış Becerileri Envanteri 2": 6,
    "Satış Becerileri Envanteri 3": 7,
    "Satış Becerileri Envanteri 4": 8,
  };

  const handleTestChange = (testKod) => {
    setAtananTestKodlari((prev) => {
      if (prev.includes(testKod)) {
        return prev.filter((item) => item !== testKod);
      } else {
        return [...prev, testKod];
      }
    });
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleGetUserData = () => {
    if (!kullanici_kod) {
      setSnackbarMessage("Lütfen kullanıcı kodunu girin.");
      setSnackbarOpen(true);
      return;
    }

    setLoading(true);

    axios
      .get(`http://localhost:5001/api/v1/participant/test-data`, {
        params: { egt_kullanici_kod: kullanici_kod },
      })
      .then((response) => {
        const { egt_ad, egt_soyad, egt_pass, atanan_test_kodlari } =
          response.data;
        setAd(egt_ad);
        setSoyad(egt_soyad);
        setPass(egt_pass);
        setAtananTestKodlari(
          atanan_test_kodlari.map((kod) =>
            Object.keys(testCodeMapping).find(
              (key) => testCodeMapping[key] === kod
            )
          )
        );
        setSnackbarMessage("Öğrenci bilgileri başarıyla getirildi!");
        setSnackbarOpen(true);
        setIsSubmitButtonDisabled(false);
      })
      .catch((error) => {
        console.error(error);
        setSnackbarMessage("Bir hata oluştu, lütfen tekrar deneyin.");
        setSnackbarOpen(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSetUserData = () => {
    if (!kullanici_kod) {
      setSnackbarMessage("Lütfen kullanıcı kodunu girin.");
      setSnackbarOpen(true);
      setSnackbarSeverity("error"); // Set Snackbar color to red for errors
      return;
    }
  
    const atanan_test_kodlari = atananTestKodlari.map((test) => testCodeMapping[test]);
    setLoading(true);
  
    axios.post("http://localhost:5001/api/v1/participant/test-assigned", {
      egt_kullanici_kod: kullanici_kod,
      atanan_test_kodlari,
      egt_ad: ad,
      egt_soyad: soyad
    })
    .then((response) => {
      console.log(response.data);
      setSnackbarMessage("Öğrenci bilgileri başarıyla güncellendi!");
      setSnackbarOpen(true);
      setSnackbarSeverity("success"); // Set Snackbar color to green for success
    })
    .catch((error) => {
      console.error(error);
      setSnackbarMessage("Bir hata oluştu, lütfen tekrar deneyin.");
      setSnackbarOpen(true);
      setSnackbarSeverity("error"); // Set Snackbar color to red for errors
    })
    .finally(() => {
      setLoading(false);
    });
  };
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: "50%",
          marginLeft: "10px",
          alignItems: "flex-start",
          border: "1px solid #ccc", // Add border
          borderRadius: "10px", // Optional: Add border radius
          padding: "30px", // Optional: Add padding inside the border
        }}
      >
        <Box
          sx={{ display: "flex", flexDirection: "row", gap: 2, width: "100%" }}
        >
          <TextField
            label="Kullanıcı Adı"
            variant="outlined"
            value={kullanici_kod}
            onChange={(e) => setKullaniciKod(e.target.value)}
            sx={{ flex: 1 }}
          />
          <Box
            sx={{ display: "flex", flexDirection: "row", gap: 2, width: "50%" }}
          >
            <Button
              onClick={handleGetUserData}
              variant="contained"
              color="primary"
              sx={{
                width: "50%",
                backgroundColor: "#1976d2",
                color: "white",
                borderRadius: "10px",
                "&:hover": {
                  backgroundColor: "#115293",
                  transform: "scale(1.001)",
                },
              }}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "KULLANICI OKU"
              )}
            </Button>
          </Box>
        </Box>
        <Paper
          elevation={0}
          variant="outlined"
          sx={{
            padding: 2,
            width: "80%",
            border: "1px solid #e0e0e0",
            borderRadius: 1,
          }}
        >
          <Typography
            variant="h6"
            sx={{ marginBottom: 2, color: "primary.main" }}
          >
            Atanacak Testler
          </Typography>
          <FormGroup>
            <Grid container spacing={2}>
              {Object.keys(testCodeMapping).map((test) => (
                <Grid item xs={6} key={test}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={atananTestKodlari.includes(test)}
                        onChange={() => handleTestChange(test)}
                        sx={{
                          "&.Mui-checked": {
                            color: "primary.main",
                          },
                        }}
                      />
                    }
                    label={test}
                  />
                </Grid>
              ))}
            </Grid>
          </FormGroup>
        </Paper>
        <Box
          sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
        >
          <Button
            onClick={handleSetUserData}
            disabled={isSubmitButtonDisabled}
            variant="contained"
            color="primary"
            sx={{
              width: "50%",
              backgroundColor: "#1976d2",
              color: "white",
              borderRadius: "10px",
              "&:hover": {
                backgroundColor: "#115293",
                transform: "scale(1.001)",
              },
            }}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "İŞLEMİ TAMAMLA"
            )}
          </Button>
        </Box>
      </Box>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AtamaIslemleri;
